module.exports = __webpack_public_path__ + "static/media/user-group.e2024164.svg";